'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var classNames = require('classnames/bind');
var Cleave = require('cleave.js/react');
var formik = require('formik');
var Input_module = require('./Input.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var Cleave__default = /*#__PURE__*/_interopDefaultLegacy(Cleave);

var cx = classNames__default["default"].bind(Input_module["default"]);
var Input = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, append = _a.append, disabled = _a.disabled, maskConfig = _a.maskConfig, name = _a.name, onBlurCallback = _a.onBlur, onChangeCallback = _a.onChange, prepend = _a.prepend, _c = _a.type, type = _c === void 0 ? 'text' : _c; _a.value; var rest = _tslib.__rest(_a, ["className", "append", "disabled", "maskConfig", "name", "onBlur", "onChange", "prepend", "type", "value"]);
    var _d = formik.useField(name), _e = _d[0], _f = _d[1], touched = _f.touched, error = _f.error, formikOnBlur = _e.onBlur, formikOnChange = _e.onChange, field = _tslib.__rest(_e, ["onBlur", "onChange"]);
    var inputClassName = cx(Input_module["default"].input, className, {
        leftPadding: prepend,
        rightPadding: append,
        disabled: disabled,
        error: touched && error !== undefined,
    });
    var onBlur = function (evt) {
        formikOnBlur(evt);
        if (onBlurCallback) {
            onBlurCallback(evt);
        }
    };
    var onChange = function (event) {
        formikOnChange(event);
        if (onChangeCallback) {
            onChangeCallback(event);
        }
    };
    var handleCleaveChange = function (event) {
        // eslint-disable-next-line no-param-reassign
        event.currentTarget.value = event.currentTarget.rawValue;
        onChange(event);
    };
    return (jsxRuntime.jsxs("div", _tslib.__assign({ className: Input_module["default"].inputContainer }, { children: [prepend && jsxRuntime.jsx("div", _tslib.__assign({ className: Input_module["default"].prepend }, { children: prepend })), maskConfig ? (jsxRuntime.jsx(Cleave__default["default"], _tslib.__assign({ className: inputClassName, options: maskConfig, onBlur: onBlur, onChange: handleCleaveChange }, field, rest))) : (jsxRuntime.jsx("input", _tslib.__assign({ className: inputClassName, disabled: disabled, onBlur: onBlur, onChange: onChange, type: type }, field, rest))), append && jsxRuntime.jsx("div", _tslib.__assign({ className: Input_module["default"].append }, { children: append }))] })));
};

exports["default"] = Input;
//# sourceMappingURL=Input.js.map
